// extracted by mini-css-extract-plugin
module.exports = {"image":"ProfilePicture_image__16ysL","profilePicture_wrapper":"ProfilePicture_profilePicture_wrapper__2o-CT","change_profile":"ProfilePicture_change_profile__JE9Oe"};